<form [formGroup]="epwconnectedRNDForm">
    <div class="main-box">
        <div class="d-flex p-2 float-end sticky-button">
            <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3" *ngIf="contractor.controls.length != 0">
              <i class="fa-solid fa-download"></i>
              <span class="hidebuttonName"> EXPORT</span>
            </button>
          </div>
        <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
            <div class="claim-table">
                <div class="table-container">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="equal-width-col"> {{ labelConstants.ContractorName }} </th>
                                    <th class="equal-width-col"> {{ labelConstants.JobRole }} </th>
                                    <th class="equal-width-col"> {{ labelConstants.CostForUk }} </th>
                                    <th class="equal-width-col"> {{ labelConstants.CostForNonUk }} </th>
                                    <th class="equal-width-col" *ngFor="let item of projectList">
                                        {{ item.projectName }}
                                    </th>
                                    <th class="equal-width-col"> {{ labelConstants.TotalQualifyingCostsForUk }} </th>
                                    <th class="equal-width-col"> {{ labelConstants.TotalQualifyingCostsForNonUk }} </th>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container formArrayName="contractor">
                                    <tr *ngFor="let item of contractor.controls; let i = index" [formGroupName]="i">
                                        <td class="equal-width-col">
                                            <span>{{ item.get("contractorName")?.value }}</span>
                                        </td >

                                        <td class="equal-width-col">
                                            <span>{{ item.get("jobRole")?.value }}</span>
                                        </td>
                                        <td class="equal-width-col">
                                            <span>{{ item.get("totalGrossPay")?.value | customCurrency:
                                                env.CurrencyFormat}}</span>
                                        </td >
                                        <td class="equal-width-col">
                                            <span>{{ item.get("totalGrossPayForNonUk")?.value | customCurrency:
                                                env.CurrencyFormat}}</span>
                                        </td>
                                        <ng-container formArrayName="projects">
                                            <td class="equal-width-col" *ngFor="let itemDetails of getProjectDetails(i).controls; let j = index"
                                                [formGroupName]="j">
                                                <span>{{ itemDetails.get("rndEligibility")?.value |
                                                    customPercentage: env.CurrencyFormat
                                                    }}</span>
                                            </td>
                                        </ng-container>
                                        <td>
                                            <span><b>{{ item.get("totalEligibilityAmount")?.value | customCurrency:
                                                    env.CurrencyFormat}}</b></span>
                                        </td>
                                        <td>
                                            <span><b>{{ item.get("totalEligibilityAmountForNonUk")?.value |
                                                    customCurrency:
                                                    env.CurrencyFormat}}</b></span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                            <tfoot *ngIf="contractor.controls && contractor.controls.length > 0; else noRecords">
                                <tr>
                                    <td colspan="2"><b> {{ labelConstants.ExternallyProvidedWorkersConnectedParties
                                            }} </b></td>
                                    <td class="equal-width-col"><b>{{getUkCostTotal() | customCurrency: env.CurrencyFormat}}</b></td>
                                    <td class="equal-width-col"><b>{{getNonUkCostTotal() | customCurrency: env.CurrencyFormat}}</b></td>
                                    <td class="equal-width-col" *ngFor="let total of projectProductTotals">
                                        <b>{{ total | customCurrency: env.CurrencyFormat}}</b>
                                    </td>
                                    <td><b>{{getUkGrandTotal() | customCurrency: env.CurrencyFormat}}</b></td>
                                    <td><b>{{getNonUkGrandTotal() | customCurrency: env.CurrencyFormat}}</b></td>
                                </tr>
                            </tfoot>
                            <ng-template #noRecords>
                                <tfoot>
                                    <tr>
                                        <td [colSpan]="6+projectList.length" class="text-center">
                                            {{commonLabelConstants.NoReacordFound}}
                                        </td>
                                    </tr>
                                </tfoot>
                            </ng-template>
                        </table>
                    </div>
                </div>
            </div>
        </app-loader>
    </div>
</form>
